import { render, staticRenderFns } from "./partner.vue?vue&type=template&id=4596bc41&scoped=true&"
import script from "./partner.vue?vue&type=script&lang=js&"
export * from "./partner.vue?vue&type=script&lang=js&"
import style0 from "./partner.vue?vue&type=style&index=0&id=4596bc41&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4596bc41",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4596bc41')) {
      api.createRecord('4596bc41', component.options)
    } else {
      api.reload('4596bc41', component.options)
    }
    module.hot.accept("./partner.vue?vue&type=template&id=4596bc41&scoped=true&", function () {
      api.rerender('4596bc41', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/user/partner/partner.vue"
export default component.exports